<template>
  <div class="SX">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoPartyDiscipline">党纪法规></span>
        <span @click="GoFenLei">分类系统></span>
        <span class="red">正文</span>
      </div>
      <!-- 正文 -->
      <div class="zhengwen">
        <h1>干部选拔任用工作监督检查和责任追究办法</h1>
        <div class="first">
          <p>近日，中共中央办公厅印发了《干部选拔任用工作监督检查和责任追究办法》，并发出通知，要求各地区各部门认真遵照执行。</p>
          <p>《干部选拔任用工作监督检查和责任追究办法》全文如下。</p>
        </div>
        <div class="date">发布时间：2020-5-20&nbsp13:30</div>
        <div class="xh"></div>

        <div class="second">
          <strong>
            <p>第一章 总则</p>
          </strong>
          <p>第一条 为了落实全面从严治党和从严管理干部要求，规范干部选拔任用工作监督检查和责任追究，根据《党政领导干部选拔任用工作条例》、《中国共产党党内监督条例》、《中国共产党问责条例》等党内法规，制定本办法。</p>

          <p>第二条 干部选拔任用工作监督检查和责任追究，坚持以习近平新时代中国特色社会主义思想为指导，贯彻新时代党的组织路线，落实新时期好干部标准，树立正确导向，突出政治监督，从严查处违规用人问题和选人用人中的不正之风，严肃追究失职失察责任，促进形成风清气正的用人生态。</p>

          <p>第三条 干部选拔任用工作监督检查和责任追究，坚持党委（党组）领导、分级负责，实事求是、依法依规，发扬民主、群众参与，分类施策、精准有效，防治并举、失责必究。</p>

          <p>
            第四条 党委（党组）及其组织（人事）部门按照职责权限，负责干部选拔任用工作的监督检查和责任追究，纪检监察机关、巡视巡察机构按照有关规定履行干部选拔任用工作监督职责。
            中央组织部负责监督检查和责任追究工作的宏观指导，地方党委组织部和垂直管理单位组织（人事）部门负责指导本地区本系统的监督检查和责任追究工作。
          </p>
          <p>第五条 本办法适用于各级党的机关、人大机关、行政机关、政协机关、监察机关、审判机关、检察机关以及事业单位、群团组织、国有企业干部选拔任用工作的监督检查和责任追究。</p>
          <strong>
            <p>第二章 监督检查重点内容</p>
          </strong>
          <p>第六条 坚持党管干部原则情况。重点监督检查是否按照干部管理权限由党委（党组）履行干部选拔任用责任，是否按照民主集中制和党委（党组）议事规则、决策程序讨论决定干部任免事项。</p>
          <p>第七条 坚持好干部标准和树立正确用人导向情况。重点监督检查是否坚持德才兼备、以德为先，坚持五湖四海、任人唯贤，坚持事业为上、公道正派；是否坚持新时期好干部标准，严把政治关、品行关、能力关、作风关、廉洁关，选拔任用忠诚干净担当的干部。</p>
          <p>第八条 执行干部选拔任用工作政策规定情况。重点监督检查是否按照机构规格和职数、资格条件、工作程序选拔任用干部；是否深入考察，认真查核，对人选严格把关；是否严格执行交流、回避、任期、退休、干部选拔任用请示报告等制度规定；是否严格落实干部管理监督制度。</p>
          <p>第九条 遵守组织人事纪律和匡正选人用人风气情况。重点监督检查是否严格遵守干部选拔任用工作纪律，是否采取有力措施严肃查处和纠正选人用人不正之风。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    GoPartyDiscipline() {
      this.$router.push("/PartyDiscipline");
    },
    GoFenLei() {
      this.$router.push("/PartyDiscipline/FenLei");
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
.zhengwen {
  width: 1200px;
  background-color: white;
  padding: 60px;
  box-sizing: border-box;
}
p {
  text-indent: 2em;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}

h1 {
  text-align: center;
  font-size: 28px;
  color: #333333;
}
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.daohang {
  margin: 20px 0;
}
.first p {
  font-weight: 600;
}
.date {
  color: #999999;
  font-size: 16px;
  text-align: center;
  margin-bottom: 20px;
}
</style>